export const formatWeight = (value: number) =>
  Math.round(value).toLocaleString();
